import React, { Component } from 'react';
import './index.less';
import Pulloffputonsaleontime from './pulloffputonsaleontime';

/**
 * 编辑定时上下架时间
 */
export class PullOffPutOnSaleOnTime extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { row, entity } = this.props;
        return (
            <div>
                <Pulloffputonsaleontime rows={row} entity={entity} />
            </div>
        );
    }
}
